import localUrl from './localUrl';

export default function urlF() {
  switch (process.env.VUE_APP_ENV) {
    case 'dev':
      return {
        baseUrl: localUrl.baseUrl,
        serviceUrl: localUrl.serviceUrl,
        platformsvc: localUrl.platformsvc,
      };
    default:
      return {
        baseUrl: process.env.VUE_APP_BASEURL,
        serviceUrl: process.env.VUE_APP_SERVICE,
        platformsvc: process.env.VUE_APP_PLATFORMSVC,
      };
  }
}
